export const FAQ = [
  {
    id: "therapy",
    q: "Is this therapy?",
    a: "No. Officium Mentale provides education and reflection tools. It does not diagnose conditions or replace psychotherapy or other qualified care. The lessons teach you to examine your own thinking and to bring better questions to a qualified provider — a psychologist, therapist, counselor, or physician.",
    link: { to: "/services", label: "What we do and don't do" },
  },
  {
    id: "cost",
    q: "What does it cost?",
    a: "The Introduction and Lesson 1 are free — no account, no card. After that it's $7 a lesson, $19 a module, or $47 for all 20 lessons, paid once with no subscription. Programs for schools, organizations, and agencies are scoped and quoted per engagement.",
    link: { to: "/pricing", label: "See pricing" },
  },
  {
    id: "signin",
    q: "What's behind Sign in?",
    a: "Your learner account. Signing in with Google (free) saves your lesson progress, your Notice / Explore / Connect reflections, your Mind Lab inquiries, and your certificates — and it's where purchased lessons unlock. You don't need it for the free Introduction and Lesson 1.",
    link: { to: "/learn/intro", label: "Start the free Introduction" },
  },
  {
    id: "privacy",
    q: "Is my information private?",
    a: "Your reflections and Mind Lab inquiries are saved to your own account and shown only to you. We don't share them with providers, employers, or anyone else — you decide what to export and hand over. Sign-in is through Google, so we never store a password. We don't sell your information. The optional weekly check-in email can be turned off in one tap.",
  },
  {
    id: "professor",
    q: "What is Professor Mentale?",
    a: "The 20-lesson course — and the calm teaching voice who narrates it. Five modules take you from observing your own mind to making deliberate choices, with a Notice / Explore / Connect investigation in every lesson. The Introduction and Lesson 1 are free.",
    link: { to: "/professor-mentale", label: "See the course" },
  },
  {
    id: "mindlab",
    q: "What is Mind Lab?",
    a: "A guided self-inquiry tool: seven levels of questions that move from an event, to the meaning you gave it, to the pattern underneath. You answer at your own pace and your answers save privately. The first two levels are free; the rest open with the course.",
    link: { to: "/mind-lab", label: "Explore the Mind Lab" },
  },
  {
    id: "provider",
    q: "How do I work with a licensed provider afterward?",
    a: "Each lesson ends with a Connect question — one you could bring to a provider. Signed-in learners can download a one-page Provider Conversation Sheet with all of their Connect questions to take to the next appointment. We don't diagnose, treat, or refer; if you need help finding licensed care, our support services can help you navigate to it. If you are in crisis, call or text 988 (veterans press 1).",
    link: { to: "/contact", label: "Ask about support services" },
  },
];

export const HOME_FAQ_IDS = ["therapy", "cost", "signin"];
